import { createHead, UnheadProvider } from '@unhead/react/client'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import { AuthProvider } from '@/context/AuthContext'
import './index.css'

const head = createHead()

createRoot(document.getElementById('root')!).render(
  <UnheadProvider head={head}>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </UnheadProvider>
)
